import React, { createContext } from 'react';
import { createViewerConfig, createViewerProvider, createUseViewers } from './ViewerContext.js';

// Create a separate context for task viewers
const TaskViewerContext = createContext();

// Create configuration for task viewers
export const taskViewerConfig = createViewerConfig({
  itemType: 'task',
  fetchAllViewers: (insightsService) => insightsService.fetchAllTaskViewers(),
  addViewerUpdateCallback: (notificationManager, callback) => 
    notificationManager.addTaskViewerUpdateCallback(callback)
});

// Create TaskViewerProvider component with its own context
export const TaskViewerProvider = createViewerProvider(TaskViewerContext, taskViewerConfig);

// Create useTaskViewers hook with its own context
export const useTaskViewers = createUseViewers(TaskViewerContext, 'task');
